import { render, staticRenderFns } from "./importHospital.vue?vue&type=template&id=0e788e66&scoped=true"
import script from "./importHospital.vue?vue&type=script&lang=js"
export * from "./importHospital.vue?vue&type=script&lang=js"
import style0 from "./importHospital.vue?vue&type=style&index=0&id=0e788e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e788e66",
  null
  
)

export default component.exports